const GUEST_ANALYSIS_MODE_KEY = 'startus:chemistry:guest-mode';

function getSessionStorage() {
    if (typeof window === 'undefined') return null;
    return window.sessionStorage;
}

export function isGuestAnalysisMode() {
    try {
        return getSessionStorage()?.getItem(GUEST_ANALYSIS_MODE_KEY) === 'enabled';
    } catch {
        return false;
    }
}

export function enableGuestAnalysisMode() {
    try {
        getSessionStorage()?.setItem(GUEST_ANALYSIS_MODE_KEY, 'enabled');
    } catch {
        // The current page can continue even when session storage is unavailable.
    }
}

export function disableGuestAnalysisMode() {
    try {
        getSessionStorage()?.removeItem(GUEST_ANALYSIS_MODE_KEY);
    } catch {
        // Ignore storage cleanup failures.
    }
}

export function hasGuestNavigationIntent(state) {
    return state?.continueAsGuest === true;
}
